import { render, staticRenderFns } from "./ListDivider.vue?vue&type=template&id=30a7625a"
import script from "./ListDivider.vue?vue&type=script&lang=js"
export * from "./ListDivider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Label: require('/vercel/path0/components/common/Label.vue').default})
